import { ReportingItemsFilterDto } from "@app/models/dashboard-activities";

export interface TopLocationActivitiesByTemplateReportRequestDto {
  startDate: string;
  endDate: string;
  period: number;
  timeZoneOffset: number;
  topCount: number;
  isGlobalTemplates: boolean;
  templateIds: number[];
  filterMode: TopNActivitiesReportFilterModeDto;
  sortDirection: TopNActivitiesReportSortDirectionDto;
}

export interface TopTerminalActivitiesReportRequestDto {
  startDate: string;
  endDate: string;
  period: number;
  timeZoneOffset: number;
  topCount: number;
  terminals: ReportingItemsFilterDto;
  locations: ReportingItemsFilterDto;
  filterMode: TopNActivitiesReportFilterModeDto;
  sortDirection: TopNActivitiesReportSortDirectionDto;
}

export interface TopTerminalActivitiesReportItemDto {
  terminalId: number;
  terminalName: string;
  scansCount: number;
  impressionsCount: number;
  clicksCount: number;
  engagementsCount: number;
}

export interface TopNActivitiesReport {
  chartType: DashboardTopNActivitiesChartType;
  filterItems: ReportingItemsFilterDto;
  filterLocations: ReportingItemsFilterDto;
  startDate: string;
  endDate: string;
  period: number;
  timeZoneOffset: number;
  topCount: number;
  filterMode: TopNActivitiesReportFilterModeDto;
  sortDirection: TopNActivitiesReportSortDirectionDto;
}

export interface TopLocationActivitiesByTemplateReportItemDto {
  locationName: string;
  locationId: number;
  scansCount: number;
  impressionsCount: number;
  clicksCount: number;
  engagementsCount: number;
}

export enum DashboardTopNActivitiesChartType {
  Locations = "locations",
  Terminals = "terminals"
}

export enum TopNActivitiesReportSortDirectionDto {
  Highest = "Highest",
  Lowest = "Lowest"
}

export enum TopNActivitiesReportFilterModeDto {
  Scans = "Scans",
  Impressions = "Impressions",
  Clicks = "Clicks",
  Engagements = "Engagements"
}

export enum TopNActivitiesReportFilterModeLegendItemIndex {
  Scans = 0,
  Impressions = 1,
  Clicks = 2,
  Engagements = 3
}
